import Vue from "vue";

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

import App from "./App.vue";
import store from "./store/index";
import router from "./router";

import VueMoment from 'vue-moment';

//Plugins
import { EventBus } from './plugins/eventbus.js';

import lang from 'view-design/dist/locale/en-US';
import vuexI18n from 'vuex-i18n';
import {
    locale,
    Time,
    Input,
    Select,
    Option,
    Switch,
    Scroll,
    Card
} from 'view-design';
import SvgIcon from 'vue-svgicon';
import Vue2TouchEvents from 'vue2-touch-events';
import { appVersion } from "./utils/helpers/versions";
import { RecycleScroller } from 'vue-virtual-scroller';
import { ResizeObserver } from 'vue-resize';
import {
    extend,
    ValidationProvider
} from 'vee-validate';
import { digits } from 'vee-validate/dist/rules';
import VueCompositionAPI from '@vue/composition-api'

if (process.env.VUE_APP_SENTRY_ENABLED) {
    Sentry.init({
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        integrations: [new Integrations.BrowserTracing({
            tracingOrigins: ['nonexistensupersomething'],
        })],
        tags: {
            version: appVersion,
        },
        environment: process.env.VUE_APP_ENVIRONMENT || 'not-set',
        release: process.env.VUE_APP_COMMIT,
        tracingOptions: {
            trackComponents: true,
        },
        attachProps: false,
        logErrors: true,
        tracesSampleRate: process.env.VUE_APP_SENTRY_TRACE_RATE || 0,
    });
}

locale(lang);
Vue.use(SvgIcon, {
    tagName: 'svg-icon'
});
Vue.use(vuexI18n.plugin, store);
Vue.use(EventBus);
Vue.use(Vue2TouchEvents);
Vue.use(VueCompositionAPI);
Vue.use(VueMoment);

Vue.component('Time', Time);
Vue.component('Input', Input);
Vue.component('Option', Option);
Vue.component('Select', Select);
Vue.component('Switcher', Switch);
Vue.component('Scroll', Scroll);
Vue.component('Card', Card);
Vue.component('RecycleScroller', RecycleScroller);
Vue.component('resize-observer', ResizeObserver);
Vue.component('ValidationProvider', ValidationProvider);

extend('digits', {
    ...digits,
    message: 'The {_field_} field must be numeric and exactly contain {length} digits'
});

Vue.directive('scroll', {
    inserted: function (el, binding) {
        const f = function (evt) {
            if (binding.value(evt, el)) {
                el.removeEventListener('scroll', f)
            }
        };
        el.addEventListener('scroll', f)
    }
});

Vue.config.productionTip = true;

if (process.env.NODE_ENV !== 'production') {
    Vue.config.devtools = true
    Vue.config.performance = true
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
